import {inject, Injectable} from '@angular/core';
import {SharedService} from './shared.service';

@Injectable({
  providedIn: 'root'
})
export class SpotUtilService {
  cLocation!: [number, number];

  sharedService = inject(SharedService);

  constructor() {
    this.setCurrentLocationToService()
  }

  /**
   * GoogleMapのURLを作成して取得
   */
  async getGoogleMapNavi(
    locationState?: any
  ) {
    await this.setCurrentLocationToService();
    if (!this.cLocation) {
      this.sharedService.openAlert(
        'エラー',
        '位置情報が取得出来ませんでした。ルート確認機能が出発地点を確認する為に位置情報機能を有効にしてご利用下さい。',
        'OK'
      );
      return;
    }
    const alert = await this.sharedService.openConfirmAlert(
      'GoogleMapに移動してよろしいですか？',
      '営業時間・定休日などは施設情報をご確認ください。',
      'OK'
    );
    if (!alert) {
      return;
    }
    return this.createGoogleMapsUrl([this.cLocation[0], this.cLocation[1]], [locationState?.location[0], locationState?.location[1]]);
  }

  createGoogleMapsUrl(currentLocation: [number, number], destination: [number, number]): string {
    const baseUrl = "https://www.google.com/maps/dir/";
    return `${baseUrl}${currentLocation[0]},${currentLocation[1]}/${destination[0]},${destination[1]}/?travelmode=walking`;
  }

  private async setCurrentLocationToService() {
    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };
    const success = (pos: any) => {
      this.cLocation = [pos.coords.latitude, pos.coords.longitude];
    }

    function error(err: any) {
      console.log(err);
    }

    navigator.geolocation.getCurrentPosition(success, error, options);
  }

}
